var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layout',{attrs:{"layout":['xs12'],"bottom-space":""}},[_c('l-data-table',{ref:"userList",attrs:{"filter-items":_vm.filterItems,"get-data-func":_vm.getUsers,"headers":_vm.userHeaders,"clickable":"","search-text":"搜索用户姓名","title-text":"登记用户列表"},on:{"click:row":function($event){return _vm.goDetails('readonly',$event.item)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }